import { render, staticRenderFns } from "./download-file.vue?vue&type=template&id=45839c6e"
import script from "./download-file.vue?vue&type=script&lang=ts"
export * from "./download-file.vue?vue&type=script&lang=ts"
import style0 from "./download-file.vue?vue&type=style&index=0&id=45839c6e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports